import './js/watch-queue';
import './js/modal';
import './js/loader';
import './js/header';
import './js/firebaseinit';
import './js/authorization-modal';
import './js/footer-modal';
import './js/render_footer_modal';